<template lang="html">
  <UAccordion
    v-if="props.terms"
    type="multiple"
    :items="items"
    :ui="{
      content: 'p-4 pt-0',
      root: 'border border-neutral-400',
      label: 'py-2 px-4',
      trailingIcon: 'mr-4',
    }"
  >
    <template #content>
      <p class="text-sm whitespace-pre-wrap text-muted">
        {{ props.terms }}
      </p>
    </template>
  </UAccordion>
</template>

<script setup lang="ts">
import type { AccordionItem } from '@nuxt/ui'

const props = defineProps<{
  terms?: string | null
  label?: string
}>()

const items = computed<AccordionItem[]>(() => [
  {
    label: props.label ?? 'Условия акции',
    value: 'promo-terms',
  },
])
</script>
